import { mapActions } from 'vuex';
import Events from '_utils/events';
import ProjectService from '_services/rest/modules/project';
import { _SAVE_PROJECT_FILE_SUCCESS_ } from './ProjectModel';

export default {
  name: 'project-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteFile() {
      ProjectService.deleteProjectFile(this.selectProject)
        .then(() => {
          this.close();
          Events.$emit(_SAVE_PROJECT_FILE_SUCCESS_, true);
          this.activeAlert({ message: 'Arquivo deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }));
    },
    deleteRow() {
      ProjectService.deleteProject(this.selectProject.id)
        .then(() => this.success('Obra deletada com sucesso'))
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }));
    },
    finishProject() {
      ProjectService.finishProject(this.selectProject.id)
        .then(() => this.success('Obra finalizada com sucesso'))
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }));
    },
    updateStatus() {
      ProjectService.updateStatus(this.selectProject)
        .then(() => this.success('Status alterado com sucesso'))
        .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }));
    },
    success(message) {
      this.close();
      this.$router.push({ name: 'admin-project-list', params: { page: 1 } });
      Events.$emit('update:pagination', false);
      this.activeAlert({ message, theme: 'success' });
    },
  },
};
